module.exports = __webpack_public_path__ + "static/media/hand-5.afc27a02.png";